import { useCallback, useState } from 'react';
import axios from '../../../../api/axios';
import useAuth from '../../../../utils/hooks/useAuth';
import { AxiosError } from 'axios';

/**
 * Custom hook for fetching company data from a URL using AI
 * Handles extracting company information from website URLs
 */
export const useCreateSessionFromUrl = () => {
  const {
    authData: { userData },
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null)

  /**
   * Fetch company data from a URL
   * @param url - The website URL to extract data from
   * @returns Promise that resolves with the extracted company data
   */
  const fetchData = useCallback(
    async (url: string): Promise<any> => {
      if (!url.trim() || !userData?.id) return null;

      setIsLoading(true);

      try {
        const response = await axios.post(
          '/ai/sessions/from-url',
          {
            url: url.trim(),
            kind: 'post_registration_assistant',
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'X-User-ID': String(userData.id),
            },
          },
        );
        return response.data;
      } catch (error) {
        console.error('Error fetching data from URL:', error);
        setError(error as any);
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    [userData?.id],
  );

  return { fetchData, isLoading, error };
};
